import React from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LspRoutes from "./Router/Router";

function App() {
  return (
    <div className='App'>
      <LspRoutes/>
      <ToastContainer/>
    </div>
  );
}

export default App;
